import { useHistory } from 'react-router-dom';
import { AuthContextValue } from './contexts/auth';


export function maskCode(phoneNumber: number | string) {
  let str = `${phoneNumber}`;
  return `${str.slice(0, 3)}****${str.slice(7)}`;
}

export function openInBrowser({ corpId, userId }: AuthContextValue) {
  window.open(`${window.location.origin}${window.location.pathname}?corpId=${corpId}&userId=${userId}`);
}

export function goBack(history: ReturnType<typeof useHistory>, url?: string) {
  if (url) {
    history.replace(`${url}${window.location.search}`);
  } else {
    history.goBack();
  }
}

export function go(history: ReturnType<typeof useHistory>, url: string) {
  history.push(`${url}${window.location.search}`);
}

export function goReplace(history: ReturnType<typeof useHistory>, url: string) {
  history.replace(`${url}${window.location.search}`);
}
